// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup_popupContainer__6GAp8 {
  padding: 30px;
  max-width: 600px;
  width: 100%;
}

.popup_popupHeader__Bdgvj {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid var(--ashyblue);
}

.popup_popupHeader__Bdgvj h1 {
  font-size: 24px;
  font-weight: 600;
  color: var(--cloudburst);
  margin: 0;
}

.popup_formGroup__vRibf {
  margin-bottom: 25px;
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.popup_formGroup__vRibf label {
  display: block;
  margin-bottom: 10px;
  font-weight: 500;
  color: var(--cloudburst);
  font-size: 14px;
}

/* Toggle Switch - Matching existing styles */
.popup_toggleSwitch__QNRjb {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
}

.popup_toggleSwitch__QNRjb input {
  opacity: 0;
  width: 0;
  height: 0;
}

.popup_slider__VLUN2 {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: #ccc;
  transition: .3s;
  border-radius: 34px;
}

.popup_slider__VLUN2:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .3s;
  border-radius: 50%;
}

input:checked + .popup_slider__VLUN2 {
  background-color: #55883D;
}

input:focus + .popup_slider__VLUN2 {
  box-shadow: 0 0 1px #55883D;
}

input:checked + .popup_slider__VLUN2:before {
  transform: translateX(24px);
}

/* Disable styling for toggle switch */
.popup_toggleSwitch__QNRjb input:disabled + .popup_slider__VLUN2 {
  background-color: #ddd;
}

.popup_toggleSwitch__QNRjb input:disabled + .popup_slider__VLUN2:before {
  background-color: #ccc;
}

/* Input Field - Matching existing styles from MenuFooter and other pages */
.popup_formGroup__vRibf input[type="number"] {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid var(--ashyblue);
  border-radius: 6px;
  font-size: 14px;
  background: var(--white);
  color: var(--darkblue);
  outline: none;
  transition: border-color 0.2s ease;
}

.popup_formGroup__vRibf input[type="number"]:focus {
  border-color: var(--cloudburst);
}

.popup_formGroup__vRibf input[type="number"]:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.popup_helpText__CCfdZ {
  margin-top: 8px;
  font-size: 13px;
  color: var(--grey);
}

.popup_buttonGroup__hZH03 {
  margin-top: 30px;
  text-align: right;
}

.popup_saveButton__gCl6V {
  background: var(--white);
  border: 1px solid var(--ashyblue);
  border-radius: 6px;
  color: var(--cloudburst);
  padding: 8px 13px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  min-height: 42px;
  display: inline-block;
}

.popup_saveButtons__iPEt1 {
    display: flex;
    justify-content: flex-end;
    width: 132.03px;
    margin-top: 25px;
    gap: 0 15px;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    line-height: 22px;
    border-radius: 6px;
    cursor: pointer;
    white-space: nowrap;
    background-color: #000;
    border-color: transparent;
    padding: 8px 13px;
    text-align: center;
    min-height: 42px;
    align-items: center;
}

.popup_saveButton__gCl6V:hover:not(:disabled) {
  background: var(--cloudburst);
  color: var(--white);
}

.popup_saveButton__gCl6V:disabled {
  background-color: #f5f5f5;
  border-color: #ddd;
  color: #999;
  cursor: not-allowed;
}

/* Success/Error Popup - Matching existing patterns from DeleteConfirmationPopup */
.popup_popupOverlay__HWl6m {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
}

.popup_popupOverlay__HWl6m.popup_show__gBibz {
  opacity: 1;
  visibility: visible;
}

.popup_popupContent__W1sKK {
  background: var(--white);
  max-width: 400px;
  width: 90%;
  position: relative;
}

.popup_popupContent__W1sKK h3 {
  margin-top: 0;
  margin-bottom: 20px;
  color: var(--cloudburst);
  font-size: 18px;
  font-weight: 600;
}

.popup_popupContent__W1sKK p {
  margin-bottom: 25px;
  color: var(--darkblue);
  line-height: 1.5;
  font-size: 14px;
}

.popup_confirmButton__6YZRW {
  background: var(--white);
  border: 1px solid var(--ashyblue);
  border-radius: 6px;
  color: var(--cloudburst);
  padding: 8px 13px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  min-height: 42px;
  display: inline-block;
}

.popup_confirmButton__6YZRW:hover {
  background: var(--cloudburst);
  color: var(--white);
}

/* Responsive design */
@media screen and (max-width: 768px) {
  .popup_popupContainer__6GAp8 {
    padding: 20px;
  }
  
  .popup_popupContent__W1sKK {
    padding: 20px;
  }
  
  .popup_popupHeader__Bdgvj h1 {
    font-size: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Appearance/Popup/popup.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,sCAAsC;AACtC;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,2EAA2E;AAC3E;EACE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,sBAAsB;EACtB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA,kFAAkF;AAClF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".popupContainer {\n  padding: 30px;\n  max-width: 600px;\n  width: 100%;\n}\n\n.popupHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding-bottom: 15px;\n  border-bottom: 1px solid var(--ashyblue);\n}\n\n.popupHeader h1 {\n  font-size: 24px;\n  font-weight: 600;\n  color: var(--cloudburst);\n  margin: 0;\n}\n\n.formGroup {\n  margin-bottom: 25px;\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.formGroup label {\n  display: block;\n  margin-bottom: 10px;\n  font-weight: 500;\n  color: var(--cloudburst);\n  font-size: 14px;\n}\n\n/* Toggle Switch - Matching existing styles */\n.toggleSwitch {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 26px;\n}\n\n.toggleSwitch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  inset: 0;\n  background-color: #ccc;\n  transition: .3s;\n  border-radius: 34px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 20px;\n  width: 20px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: .3s;\n  border-radius: 50%;\n}\n\ninput:checked + .slider {\n  background-color: #55883D;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #55883D;\n}\n\ninput:checked + .slider:before {\n  transform: translateX(24px);\n}\n\n/* Disable styling for toggle switch */\n.toggleSwitch input:disabled + .slider {\n  background-color: #ddd;\n}\n\n.toggleSwitch input:disabled + .slider:before {\n  background-color: #ccc;\n}\n\n/* Input Field - Matching existing styles from MenuFooter and other pages */\n.formGroup input[type=\"number\"] {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1px solid var(--ashyblue);\n  border-radius: 6px;\n  font-size: 14px;\n  background: var(--white);\n  color: var(--darkblue);\n  outline: none;\n  transition: border-color 0.2s ease;\n}\n\n.formGroup input[type=\"number\"]:focus {\n  border-color: var(--cloudburst);\n}\n\n.formGroup input[type=\"number\"]:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.helpText {\n  margin-top: 8px;\n  font-size: 13px;\n  color: var(--grey);\n}\n\n.buttonGroup {\n  margin-top: 30px;\n  text-align: right;\n}\n\n.saveButton {\n  background: var(--white);\n  border: 1px solid var(--ashyblue);\n  border-radius: 6px;\n  color: var(--cloudburst);\n  padding: 8px 13px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  min-height: 42px;\n  display: inline-block;\n}\n\n.saveButtons {\n    display: flex;\n    justify-content: flex-end;\n    width: 132.03px;\n    margin-top: 25px;\n    gap: 0 15px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #fff;\n    line-height: 22px;\n    border-radius: 6px;\n    cursor: pointer;\n    white-space: nowrap;\n    background-color: #000;\n    border-color: transparent;\n    padding: 8px 13px;\n    text-align: center;\n    min-height: 42px;\n    align-items: center;\n}\n\n.saveButton:hover:not(:disabled) {\n  background: var(--cloudburst);\n  color: var(--white);\n}\n\n.saveButton:disabled {\n  background-color: #f5f5f5;\n  border-color: #ddd;\n  color: #999;\n  cursor: not-allowed;\n}\n\n/* Success/Error Popup - Matching existing patterns from DeleteConfirmationPopup */\n.popupOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.3s, visibility 0.3s;\n}\n\n.popupOverlay.show {\n  opacity: 1;\n  visibility: visible;\n}\n\n.popupContent {\n  background: var(--white);\n  max-width: 400px;\n  width: 90%;\n  position: relative;\n}\n\n.popupContent h3 {\n  margin-top: 0;\n  margin-bottom: 20px;\n  color: var(--cloudburst);\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.popupContent p {\n  margin-bottom: 25px;\n  color: var(--darkblue);\n  line-height: 1.5;\n  font-size: 14px;\n}\n\n.confirmButton {\n  background: var(--white);\n  border: 1px solid var(--ashyblue);\n  border-radius: 6px;\n  color: var(--cloudburst);\n  padding: 8px 13px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  min-height: 42px;\n  display: inline-block;\n}\n\n.confirmButton:hover {\n  background: var(--cloudburst);\n  color: var(--white);\n}\n\n/* Responsive design */\n@media screen and (max-width: 768px) {\n  .popupContainer {\n    padding: 20px;\n  }\n  \n  .popupContent {\n    padding: 20px;\n  }\n  \n  .popupHeader h1 {\n    font-size: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popupContainer": `popup_popupContainer__6GAp8`,
	"popupHeader": `popup_popupHeader__Bdgvj`,
	"formGroup": `popup_formGroup__vRibf`,
	"toggleSwitch": `popup_toggleSwitch__QNRjb`,
	"slider": `popup_slider__VLUN2`,
	"helpText": `popup_helpText__CCfdZ`,
	"buttonGroup": `popup_buttonGroup__hZH03`,
	"saveButton": `popup_saveButton__gCl6V`,
	"saveButtons": `popup_saveButtons__iPEt1`,
	"popupOverlay": `popup_popupOverlay__HWl6m`,
	"show": `popup_show__gBibz`,
	"popupContent": `popup_popupContent__W1sKK`,
	"confirmButton": `popup_confirmButton__6YZRW`
};
export default ___CSS_LOADER_EXPORT___;
